import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  .header {
    padding: 16px;
    border-bottom: 1px solid #96989a;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }

    button {
      border: none;
      background-color: transparent;
      height: 22px;
      cursor: pointer;
    }
  }
`;

export const Body = styled.div`
  padding: 16px 32px;

  .action_container {
    display: flex;
    gap: 16px;

    button {
      padding: 8px 16px;
      border-radius: 5px;
      border: 1px solid #000;
      font-size: 14px;
      font-weight: 500;
      background-color: #fff;
      cursor: pointer;
      font-style: normal;
      line-height: normal;
    }
  }

  .infos_data {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      color: #282828;
      margin: 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;

  button {
    cursor: pointer;
    background-color: var(--color-primary);
    color: #fff;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 5px;
    border: none;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    gap: 16px;
  }

  .add_collab_container {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .email_input {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #282828;
    min-width: 280px;

    &:disabled {
      background-color: #96989a;
      border: 1px solid #96989a;
    }
  }

  button {
    padding: 8px 16px;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    font-size: 12.8px;
    font-style: normal;
    line-height: normal;
  }

  .go_back {
    color: #000;
    background-color: transparent;
    border: 1px solid #000;
  }
`;

export const Button = styled.button`
  background-color: transparent;
  background-color: ${({ active }) =>
    active ? "var(--color-primary)" : "#fff"};
  border: 1px solid
    ${({ active }) => (active ? "var(--color-primary)" : "#000")};
  color: ${({ active }) => (active ? "#fff" : "#000")};
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #282828;
  min-width: 280px;
  height: fit-content;

  &:disabled {
    background-color: #96989a;
  }
`;

export const CollaboratorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      cursor: pointer;
    }
  }

  p {
    color: #282828;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0px;
  }

  button {
    border: none;
    background-color: transparent;
    height: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ButtonInvitation = styled.button`
  background-color: ${({ active }) =>
    active ? "var(--color-primary)" : "#96989A"};
  color: #fff;
  border: 1px solid
    ${({ active }) => (active ? "var(--color-primary)" : "#96989A")};
  cursor: ${({ active }) => (active ? "pointer" : "not-allowed")};
`;
